export function toggleLandingPage(open) {
  return {
    type: open ? "OPEN_LANDING_PAGE" : "CLOSE_LANDING_PAGE",
  };
}
